import { capitalize, joinWithAnd } from 'lib/textHelper'

const isPresent = value => value && value.trim()
const isEmail = value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)

const FIELDS_TO_NAMES = {
  jobTitle: 'профессию',
  companyTitle: 'название компании',
  jobLocation: 'город',
  contactEmail: 'эл. почту для откликов',
}

export default class BurosferaVacancyFormValidator {
  constructor(state) {
    this.state = state
  }

  get isJobTitleValid() { return isPresent(this.state.jobTitle) }

  get isCompanyTitleValid() { return isPresent(this.state.companyTitle) }

  get isJobDescriptionValid() { return isPresent(this.state.jobDescription) }

  get isJobLocationValid() { return isPresent(this.state.jobLocation) || this.state.jobFormat === 'remote' }

  get isContactEmailValid() { return isEmail(this.state.contactEmail) }

  get isValid() {
    return this.isJobTitleValid &&
      this.isCompanyTitleValid &&
      this.isJobLocationValid &&
      this.isContactEmailValid &&
      this.isJobDescriptionValid
  }

  get validationMessage() {
    if (this.isValid) return null

    const fieldsToFill = Object.keys(FIELDS_TO_NAMES)
      .filter(field => !this[`is${capitalize(field)}Valid`])
      .map(field => FIELDS_TO_NAMES[field])

    if (this.isJobDescriptionValid) {
      return `Укажите ${joinWithAnd(fieldsToFill)}, чтобы опубликовать вакансию`
    }

    if (fieldsToFill.length) {
      return `Укажите ${fieldsToFill.join(', ')} и расскажите о вакансии, чтобы её опубликовать`
    }

    return 'Расскажите о вакансии, чтобы её опубликовать'
  }
}
